export enum ChatVariant {
  DEFAULT = 'default',
  EXPANDED = 'expanded',
}
